export const copyToClipboard = async (value: string): Promise<void> => {
  await navigator.clipboard.writeText(value);
};